module.exports = __webpack_public_path__ + "impact.52003468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/chatbotmakers/impact.png
// module id = 927
// module chunks = 0